import { keepPreviousData } from '@tanstack/react-query';

import { Scheduling, SchedulingId } from '@playq/services-jobot-scheduler';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { integrationGetKeys } from './constants';

export const useIntegrationGet = (
  id?: SchedulingId,
  options?: IUseQueryOptionsExtended<Scheduling | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(
    integrationGetKeys.concat(id),
    () => services2.integrationsService.retrieve(id as SchedulingId),
    {
      placeholderData: keepPreviousData,
      ...options,
      enabled: (options?.enabled ?? true) && id !== undefined,
    }
  );

  return {
    integration: res.data,
    ...res,
  };
};
